import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export const Lightbox = ({ images, index, onClose, onNav }) => {
  const [i, setI] = useState(index);

  useEffect(() => setI(index), [index]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") move(1);
      if (e.key === "ArrowLeft") move(-1);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
    // eslint-disable-next-line
  }, [i]);

  const move = (d) => {
    const next = (i + d + images.length) % images.length;
    setI(next);
    onNav && onNav(next);
  };

  if (index === null) return null;

  return (
    <AnimatePresence>
      <motion.div
        data-testid="lightbox"
        className="fixed inset-0 z-[70] bg-ink/97 backdrop-blur-xl flex items-center justify-center"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <button data-testid="lightbox-close" onClick={onClose} className="absolute top-8 right-8 text-cream/70 hover:text-gold transition-colors z-10">
          <X size={30} />
        </button>
        <button data-testid="lightbox-prev" onClick={() => move(-1)} className="absolute left-4 md:left-10 text-cream/60 hover:text-gold transition-colors">
          <ChevronLeft size={44} />
        </button>
        <button data-testid="lightbox-next" onClick={() => move(1)} className="absolute right-4 md:right-10 text-cream/60 hover:text-gold transition-colors">
          <ChevronRight size={44} />
        </button>
        <motion.img
          key={i}
          src={images[i]}
          alt=""
          initial={{ opacity: 0, scale: 0.98 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="max-h-[85vh] max-w-[88vw] object-contain"
        />
        <span className="absolute bottom-8 text-xs uppercase tracking-[0.3em] text-muted2">
          {String(i + 1).padStart(2, "0")} / {String(images.length).padStart(2, "0")}
        </span>
      </motion.div>
    </AnimatePresence>
  );
};
